<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            View company
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body row">
          <!-- Company name -->
          <div class="form-group col-xs-12 col-sm-6">
            <label>Company name</label>
            <div>{{ company.name }}</div>
          </div>

          <!-- Company Address -->
          <div class="form-group col-xs-12 col-sm-6" >
            <label>Address</label>
            <div>{{ company.address }}</div>
          </div>

          <!-- Company Website -->
          <div class="form-group col-xs-12 col-sm-6">
            <label>Website</label>
            <div>{{ company.website }}</div>
          </div>

          <!-- Phone Number -->
          <div class="form-group col-xs-12 col-sm-6">
            <label>Phone Number</label>
            <div>{{ company.phoneNumber }}</div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewCompanyModal',
  props: [ 'modalId', 'companyData' ],
  data () {
    return {
      company: {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      }
    }
  },
  watch: {
    companyData: function (newCompanyData) {
      this.company = newCompanyData
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ViewCompanyModal.vue?f6d47f80